import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { selectPartnersForUpdate } from '../services/selectors';
import { updatePartnersRequest } from '../services/actions';
import { forms } from '../services/config';

import PartnersForm from '../components/PartnersForm';

const form = forms.updatePartnersForm;

export default compose(
    connect(state => ({
        initialValues: selectPartnersForUpdate(state),
    })),
    reduxForm({
        form,
        onSubmit: (values, dispatch) => {
            dispatch(updatePartnersRequest(form, values));
        },
    }),
)(PartnersForm);
